export const getSafeRedirect = (
  search: string,
  fallback = "/app",
): string => {
  const candidate = new URLSearchParams(search).get("redirect");

  if (
    !candidate ||
    !candidate.startsWith("/") ||
    candidate.startsWith("//") ||
    candidate.includes("\\")
  ) {
    return fallback;
  }

  return candidate;
};
